import { lazy } from 'react';

export const routes = [
    {
        component: lazy(() => import('module/activity/Activity')),
        permissions: [],
        path: '/activity-export',
    },
];
